// This endpoint is used to test that Loki is working end to end

import { lokiRequest } from './../dataLayer/lokiRequest';

export type UserInfo = {
    officeLocation: string | null;
    workPhone: string | null;
    imAddress: string | null;
    extraEmails: Array<string> | null;
    mobilePhone: string | null;
    city: string | null;
    companyName: string | null;
    businessPhones: Array<string> | null;
    homePhones: Array<string> | null;
    otherPhones: Array<string> | null;
    userType: string | null;
    accountEnabled: boolean | null;
    personaId: string | null;
    givenName: string | null;
    surname: string | null;
    birthday: string | null;
    yomiCompany: string | null;
    webSites: Array<any> | null;
    postalAddresses: Array<any> | null;
    sources: Array<any> | null;
    isWritable: boolean | null;
    homeLocation: string | null;
    nickname: string | null;
    assistantName: string | null;
    spouseName: string | null;
    weddingAnniversary: string | null;
    schools: Array<string> | null;
    interests: Array<string> | null;
    isExplicitContact: boolean | null;
    mobilePhoneUrl: string | null;
    mobilePhoneInfo: any | null;
    businessPhoneInfo: Array<any> | null;
    homePhoneInfo: Array<any> | null;
    otherPhoneInfo: Array<any> | null;
    workPhoneUrl: string | null;
    workPhoneInfo: any | null;
    businessPhoneNumbersAndUrls: Array<any> | null;
    imAddressUrl: string | null;
    imAddressInfo: any | null;
    aadObjectId: string | null;
    fullName: string | null;
    email: string | null;
    jobTitle: string | null;
    userPrincipalName: string | null;
    department: string | null;
};

export async function getUserInfo(userSmtp: string): Promise<UserInfo> {
    const path = 'api/beta/userinfo';
    const queryParameters: { [key: string]: string } = {
        userSmtp: userSmtp,
    };

    try {
        const response = await lokiRequest('GET', path, queryParameters);
        if (response.ok) {
            return response.json();
        }

        return Promise.reject(response.status);
    } catch (error) {
        return Promise.reject(error);
    }
}
